import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { REPORT_RANGES } from "../../../../../store/constants";
import { Box, Text, VStack } from "@chakra-ui/react";

import {
  updateLocalSubscription,
} from "../../../../../store/actions/subscriptionsActions";

import Select from "../../../../averly/Select";
import Input from "../../../../averly/Input";

const ReportRangeSelection = () => {
  const dispatch = useDispatch();
  const { subscription } = useSelector((state) => state.subscriptionsReducer);
  const hasReports = !_.isEmpty(subscription.reports);
  const isExistingSubscription = !_.isEmpty(subscription.id);
  const isRangeDisabled = isExistingSubscription || hasReports;

  // Convert report range to display format (e.g., "day" -> "Daily")
  const reportRangeString = (value) => {
    const rangeMap = {
      day: "Daily",
      week: "Weekly",
      month: "Monthly",
    };
    return rangeMap[value] || "";
  }

  // Delivery schedule mapping
  const DELIVERY_SCHEDULES = useMemo(
    () => ({
      Monthly: "1st day of every month",
      Weekly: "Every Monday",
      Daily: "Start of every business day",
    }),
    []
  );

  const RANGE_OPTIONS = useMemo(
    () => [
      { name: "Monthly", id: REPORT_RANGES.MONTH },
      { name: "Weekly", id: REPORT_RANGES.WEEK },
      { name: "Daily", id: REPORT_RANGES.DAY },
    ],
    []
  );


  return (
    <Box className="subscriptionDetailsSection">
      <VStack alignItems="stretch" gap="12px">
        <Input
          label="Name"
          placeholder="Enter report subscription name"
          value={subscription.subscriptionName || ""}
          onChange={(value) =>
            dispatch(updateLocalSubscription({ ...subscription, subscriptionName: value }))
          }
        />
        <Select
          label="Report Range"
          placeholder={!subscription.reportRange ? "Select Report Range" : undefined}
          value={subscription.reportRange || ""}
          options={RANGE_OPTIONS}
          disabled={isRangeDisabled}
          onChange={(value) =>
            dispatch(updateLocalSubscription({ ...subscription, reportRange: value }))
          }
        />
        {!_.isEmpty(subscription.reportRange) ? (
          <Text className="subscriptionDetailsHelper">
            Delivery: {DELIVERY_SCHEDULES[reportRangeString(subscription.reportRange)] || "N/A"}
          </Text>
        ) : null}
        {isRangeDisabled ? (
          <Text className="subscriptionDetailsHelper">
            Report range is locked once the subscription period is set or reports are selected.
          </Text>
        ) : null}
      </VStack>
    </Box>
  );
};

export default ReportRangeSelection;
